import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';

import { CerberusStatsRpiChart } from '../../components';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants';
import { useZipRpiTimeSeries } from '../../hooks';

const dataHcName = 'zip-rpi-chart';

interface ZipHpiChartProps {
  className?: string;
  zipcode: string;
  propertyType: 'singleFamily' | 'condo';
  fromDate?: DateStr;
  toDate?: DateStr;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const ZipRpiChart = ({
  zipcode,
  className,
  propertyType,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  theme,
}: ZipHpiChartProps) => {
  const { data, isLoading } = useZipRpiTimeSeries({
    zipcode,
    fromDate,
    toDate,
    propertyType,
  });
  return (
    <CerberusStatsRpiChart
      dataHcName={dataHcName}
      className={className}
      data={data}
      theme={theme}
      isLoading={isLoading}
    />
  );
};
